import { dataService } from 'App';
import { FORM_MULTI_HEADERS_CONF, FORM_URL_ENCODED_HEADERS_CONF } from 'utils/requestHelpers';

const omccServiceUrl='/omcc';

export function getPackageList() {
  return dataService.get(
    `${omccServiceUrl}/retrievePackageList`,
  );
}

export function getDefaultPackageList() {
  return dataService.get(
    `${omccServiceUrl}/packageList`,
  );
}

export function getUserStatus() {
  return dataService.get(
    `${omccServiceUrl}/getUserAuthStatus`,
  );
}


export function getCurrentToS() {
  return dataService.get(
    `${omccServiceUrl}/getCurrentTermsOfServiceText`,
  );
}

export function getPaycellCreditCards() {
  return dataService.get(
    `${omccServiceUrl}/retrievePaycellCreditCard`,
  );
}

export function getPaycellToS() {
  return dataService.get(
    `${omccServiceUrl}/getPaymentMethodsWithTermsOfService`,
  );
}

export function getPaycellMethodWithAlias() {
  return dataService.get(
    `${omccServiceUrl}/getPaymentMethodsWithAlias`,
  );
}


export function getCreditCardToken(data) {
  return dataService.post(
    `${omccServiceUrl}/getCreditCardToken`, data
  );
}


export function getThreeDSessionId(data) {
  const searchParams = new URLSearchParams();
  for (const prop in data) {
    searchParams.set(prop, data[prop]);
  }
  return dataService.post(
    `${omccServiceUrl}/getThreeDSessionId`, searchParams,  FORM_URL_ENCODED_HEADERS_CONF 
  );
}


export function getMaxAmount() {
  return dataService.get(
    `${omccServiceUrl}/getUserMaxAmount`,
  );
}

export function buyingViaCreditCardChecks() {
  return dataService.get(
    `${omccServiceUrl}/buyingViaCreditCardChecks`,
  );
}

export function chargePackage(data) {
  const searchParams = new URLSearchParams();
  for (const prop in data) {
    searchParams.set(prop, data[prop]);
  }
  return dataService.post(
    `${omccServiceUrl}/chargePackage`,searchParams,  FORM_URL_ENCODED_HEADERS_CONF 
  );
}



export function getVirtualInvoices() {
  return dataService.get(
    `/ActivateVirtualinvoice/getvirtualinvoice`,
  );
}

export function getVirtualInvoicesChecks() {
  return dataService.get(
    `/ActivateVirtualinvoice/getvirtualinvoiceChecks`,
  );
}

export function createVirtualInvoices(data) {
  
  let form = new FormData();
  form.append("paketNO",data.paketNO);
  form.append("paketAdi",data.paketAdi);
  form.append("couponCode",data.couponCode);
  return dataService.post(
    `/ActivateVirtualinvoice/createvirtualinvoice`,data 
  );
}



export function checkCouponCode(couponCode) {
  return dataService.get(
    `${omccServiceUrl}/getCoupon/${couponCode}`
  );
}





export const  sendOtp  = (selectedId,purchaseType)=>  {
  var postData = 'selectedId=' + selectedId +  '&purchaseType='+parseInt(purchaseType);
  return dataService.post(
    `${omccServiceUrl}/otp/send`, postData    
  );
}

export const validateOtp = (otp)=> {
  var postData = 'otp=' + otp;
  
  return dataService.post(
    `${omccServiceUrl}/otp/validate`, postData    
  );
}